import "./ContentCardStyles.scss";
import $ from "jquery";
import { applyHoverZoomEffectWrapper, evenHeightsV2, getCompanyInfoCookie, isNotUndefined } from "../FunctionsCore";
// TODO It should not be necessary to limit this function to one execution
let run = true;
const contentCard = (contentCardParameter) => {
    if (run) {
        run = false;
        $(() => {
            if (contentCardParameter.newConfiguration && !contentCardParameter.errorSendingEmail) {
                // TODO Where does this come from?
                $(".order-email-failure").hide();
            }
            $(".row")
                .has(".card, .content_card")
                .each((_, element) => {
                evenHeightsV2(element, ".card .description, .content_card .description");
                evenHeightsV2(element, ".card .title, .content_card .title");
                evenHeightsV2(element, ".card button, .content_card button, .card .button, .content_card .button");
            });
        });
    }
    $(() => {
        applyHoverZoomEffectWrapper(contentCardParameter.applyHoverZoomEffectWrapperParameter);
        // Replace {{company_name}} with info from cookie in content card text
        const contentCardId = contentCardParameter.identifier;
        const $selector = $(`.content_card .${contentCardId} .meta`);
        const $companyPh = $selector.find(".company-ph");
        const $noCompanyPh = $selector.find(".no-company-ph");
        if ($companyPh.length > 0) {
            $companyPh.hide();
            $noCompanyPh.show();
            const companyInformationForCookie = getCompanyInfoCookie();
            if (isNotUndefined(companyInformationForCookie)) {
                const { companyName } = companyInformationForCookie;
                if (isNotUndefined(companyName) && companyName.length > 0) {
                    const text = $companyPh.text();
                    const updatedText = text.replace("{{company_name}}", companyName);
                    $companyPh.text(updatedText);
                    $noCompanyPh.hide();
                    $companyPh.show();
                }
            }
        }
    });
};
export { contentCard };
